let menuUtil = {
  GLOBAL: {
    isDebug: false,
  },
}

menuUtil.oneOf = function (ele, targetArr) {
  if (targetArr.indexOf(ele) >= 0) {
    return true
  } else {
    return false
  }
}

menuUtil.getRouterObjByName = function (routers, name) {
  if (!name || !routers || !routers.length) {
    return null
  }
  // debugger;
  let routerObj = null
  for (let item of routers) {
    if (item.name === name) {
      return item
    }
    routerObj = menuUtil.getRouterObjByName(item.children, name)
    if (routerObj) {
      return routerObj
    }
  }
  return null
}

// 生成唯一id，用于判断唯一菜单，或tag
menuUtil.generateId = function (routers, parentNode) {
  if (!routers || !routers.length) {
    return routers
  }
  for (var i = 0; i < routers.length; i++) {
    var item = routers[i]
    // 没有设置则生成
    if (!item.id) {
      item.id = item.title + '-' + item.name
    }
    // 用于记录菜单关系，展开对应菜单
    if (parentNode) {
      item.parentName = []
      // 父类id优先添加
      if (parentNode.parentName) {
        item.parentName.push(...parentNode.parentName)
      }
      // 当前节点追加
      item.parentName.push(parentNode.id)
      // console.info('item.parentName', item.parentName);
    }
    menuUtil.generateId(item.children, item)
  }
  // if(this.GLOBAL.isDebug)console.log("menuUtil.generateI", item.parentName);
  return routers
}

// 获取菜单定义，根据唯一id
menuUtil.getRouterObjById = function (routers, id) {
  if (!id || !routers || !routers.length) {
    return null
  }
  // debugger;
  let routerObj = null
  for (let item of routers) {
    if (item.id === id) {
      return item
    }
    routerObj = menuUtil.getRouterObjById(item.children, id)
    if (routerObj) {
      return routerObj
    }
  }
  return null
}

/**
//将树形结构转成1维数组
treeList :树形列表
targetArr：目标一维数组，
childrenField：子节点属性名
parentNode：父类节点

data=[
  {
    name:"1",
    children:[
        {
          name:"1-1",
          children:[
                {
                  name:"1-1-1",
                  children:[
                ]
              }
        ]
      }
  ]
  }

]

=>

data=[
  {
    name:"1",
    children:[

  ]
  },
  {
    name:"1-1",
    parentNode:["1"]
    children:[

  ]
  },
  {
          name:"1-1-1",
          parentNode:["1","1-1"]
          children:[
        ]
      }

]

*/

menuUtil.TreeListToNoTreeList = function (treeList, targetArr, childrenField, parentNode) {
  if (!treeList) return null
  if (!targetArr) targetArr = []
  if (!childrenField) childrenField = 'children'
  for (var i = 0; i < treeList.length; i++) {
    var node = treeList[i]
    // 没有设置则生成
    if (!node.id) {
      node.id = node.title + '-' + node.name
    }
    // 已后台数据为准，兼任根据js router配置。
    // if(!node.component)node.component=node.name;
    // 用于记录菜单关系，展开对应菜单
    if (parentNode) {
      node.parentName = []
      // 父类id优先添加
      if (parentNode.parentName) {
        node.parentName.push(...parentNode.parentName)
      }
      // 当前节点追加
      node.parentName.push(parentNode.id)
      // console.info('node.parentName', node.parentName);
    }
    // 特殊标志位，标识无需要定位菜单
    if (parentNode && parentNode.name == 'otherRouter') {
      node.noLeftMenu = true
      // console.info('parentNode.name,node.noLeftMenu', parentNode.name, node);
    }
    //处理缓存
    if (node.property?.meta) {
      node.meta = node.property.meta
    }
    targetArr.push(node)
    if (node[childrenField]) {
      menuUtil.TreeListToNoTreeList(node[childrenField], targetArr, childrenField, node)
    }
  }
  return targetArr
}

// 根据名字获取菜单。Util.getmenuByName(menuList,name)
menuUtil.getmenuByName = function (menuList, name) {
  for (let item of menuList) {
    if (item.name === name) {
      return item
    }
  }
  return null
}

//创建页面路由，对于不同路由使用同一个页面时需要保持缓存时使用
menuUtil.createdRouteComponent = function ({ name, path }) {
  return {
    name,
    components: {
      pageViewComponent: path,
    },
    render(h) {
      return h('pageViewComponent')
    },
  }
}

export default menuUtil
